import ProfileFormContainer from './profile_form_container';

const ProfileForm = ProfileFormContainer;
export default ProfileForm;
